'use client';


const THEME_KEY = 'bioinfometrics-theme';

export function ThemeInit() {
  const code = `
    try {
      var val = localStorage.getItem('${THEME_KEY}');
      var prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      var root = document.documentElement;
      if (val === 'dark' || (!val && prefersDark)) {
        root.classList.add('dark');
        root.style.colorScheme = 'dark';
      } else {
        root.classList.remove('dark');
        root.style.colorScheme = 'light';
      }
    } catch {}
  `;

  return <script dangerouslySetInnerHTML={{ __html: code }} />;
}
